import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { phases, systemIncludes, tools } from '../data/system';
export function SystemBlueprint() {
  return <section aria-label="The 6-step full-distance blueprint" className="bg-navy text-white" data-id="element-245" data-mp="29sbrptbvo7vl">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "20px",
      paddingBottom: "28px"
    }} data-id="element-246" data-mp="24u0j1lxbk3ey">
        <div className="mx-auto max-w-3xl text-center" data-id="element-247" data-mp="1zx1ox3dnnwgr">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-248" data-mp="1vtvls4lualei">
            The Full Distance Triathlon System™ · Complete 6-phase operating system
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[0.95] sm:text-6xl" data-id="element-249" data-mp="1lw7debvb9fdv">
            One system to organize the entire journey from training to finish line.
          </h2>
          <p className="mt-5 text-lg font-semibold text-white/70" data-id="element-250" data-mp="3ga8ez4i8wghn">The 6-Step Full-Distance Blueprint</p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-251" data-mp="ywbv4gvo9294">
          {phases.map((p, idx) => {
          const Icon = p.icon;
          return <motion.article key={p.n} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: idx % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-obsidian/60 p-6" data-id="element-252" data-mp="12zhxvejksbau" data-mpi={idx}>
                <div className="flex items-center justify-between" data-id="element-253" data-mp="1mnz43jsz9sn4">
                  <span className="font-display text-5xl font-extrabold leading-none text-electric" data-id="element-254" data-mp="17wqjjp3xmxgu">{p.n}</span>
                  <span className="rounded-md border border-aqua/25 bg-aqua/10 px-2 py-1 text-[11px] font-semibold uppercase tracking-wider text-aqua" data-id="element-255" data-mp="1cuiekrzvizp9">
                    {p.weeks}
                  </span>
                </div>
                <div className="mt-4 flex gap-1" aria-hidden="true" data-id="element-256" data-mp="2f8mdoeuipg37">
                  {phases.map((_, k) => <span key={k} className={cn('h-1 flex-1 rounded-full', k < idx ? 'bg-perf' : k === idx ? 'bg-electric' : 'bg-white/10')} data-id="element-257" data-mp="2f69y28c8fhtb" data-mpi={k} />)}
                </div>
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase leading-tight" data-id="element-258" data-mp="258vlwkxcdf6t">{p.title}</h3>
                <p className="mt-2 font-semibold leading-snug text-white" data-id="element-259" data-mp="218lhhcp76wu2">{p.lead}</p>
                <p className="mt-2 text-sm leading-relaxed text-white/65" data-id="element-260" data-mp="1wbctuwla60lf">{p.desc}</p>
                <p className="mt-auto flex items-center gap-2 pt-5 text-xs font-semibold uppercase tracking-wider text-white/45" data-id="element-261" data-mp="1ri9yqk0uuj34">
                  <Icon className="h-4 w-4 text-aqua" aria-hidden="true" data-id="element-262" data-mp="1mhw1zy4pevke" />
                  Phase {p.n} of 06
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-14" data-id="element-263" data-mp="1dir48u0yv69a">
          <p className="text-center font-display text-2xl font-extrabold uppercase sm:text-3xl" data-id="element-264" data-mp="1dl3iox7imyhl">
            Plus 4 performance tools
          </p>
          <p className="mt-2 text-center text-sm text-white/60" data-id="element-265" data-mp="3k6hqougo3hlu">
            Everything connected in one complete triathlon operating system.
          </p>
          <ol className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 lg:grid-cols-4" data-id="element-266" data-mp="3t87r2psj1qvr">
            {tools.map(({
            verb,
            name,
            icon: Icon
          }) => <li key={verb} className="flex flex-col gap-3 bg-navy p-5" data-id="element-267" data-mp="31hbdfmyn7i7f">
                <Icon className="h-5 w-5 text-electric" aria-hidden="true" data-id="element-268" data-mp="31eypmt67edmg" />
                <p className="font-display text-3xl font-extrabold uppercase leading-none" data-id="element-269" data-mp="35j6bmila1fgz">{verb}</p>
                <p className="text-sm leading-snug text-white/60" data-id="element-270" data-mp="3ag6hase7sg7k">{name}</p>
              </li>)}
          </ol>
        </div>

        <div className="mt-14 rounded-2xl border border-white/10 bg-obsidian/50 p-6 sm:p-8" data-id="element-271" data-mp="3faasxoyfdcez">
          <p className="font-display text-2xl font-extrabold uppercase" data-id="element-272" data-mp="2hqzma3dyy8r2">Each part of the system includes</p>
          <ul className="mt-6 grid gap-x-6 gap-y-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-273" data-mp="2mpsrl8j3qtg5">
            {systemIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] text-white/80" data-id="element-274" data-mp="oabo3gx8iwn4">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-275" data-mp="121q9fuem79xc" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}